module.exports = __webpack_public_path__ + "static/media/21-herleg.96d477e8.mp3";